import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Platform from '@app/components/Landing/Platform'
import ActionButton from '@app/components/ui/buttons/ActionButton'
import StateLabel from '@app/components/shared/StateLabel'
import Logo from '@app/components/shared/Logo'
import Friendship from '@app/components/shared/StateLabel/Friendship'
import { LandingPart } from '@app/components/shared/students/LandingPart'
import Loader from '@app/components/ui/placeholders/Loader'
import { Student } from '@app/models/users'
import classnames from 'classnames'

class Start extends Component {
  constructor(props) {
    super(props)
    this.handleStart = this.handleStart.bind(this)
  }

  handleStart(_) {
    const { boundStudentActions } = this.props
    boundStudentActions.participate({ tour: 'trial' })
  }

  componentDidMount() {
    this.handleStart();
  }

  render() {
    const { student, global, participate: { starting } } = this.props

    const classes = classnames(
      'page', 'student-tasks-page',
      'student-tasks-page--landing'
    )

    return (
      <Loader />
    )
  }
}

Start.propTypes = {
  boundStudentActions: PropTypes.object.isRequired,
  student: PropTypes.instanceOf(Student).isRequired,
  participate: PropTypes.object.isRequired
}

export default Start
